// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3DC_J","label":"LabeledBox_label__1jcoF"};